"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBrowser = exports.getPillUrlWithReferrer = void 0;

var _queryString = _interopRequireDefault(require("query-string"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var isBrowser = function isBrowser() {
  return typeof document !== 'undefined' && typeof window !== 'undefined';
};

exports.isBrowser = isBrowser;

var getPillUrlWithReferrer = function getPillUrlWithReferrer(pillURL, referrer) {
  var pillReferrer = referrer || (isBrowser() ? window.location.href : null);
  var newUrl = pillReferrer ? _queryString["default"].stringifyUrl({
    url: pillURL,
    query: {
      'x-referrer': pillReferrer
    }
  }) : pillURL;
  return newUrl;
};

exports.getPillUrlWithReferrer = getPillUrlWithReferrer;